'use client';

import React from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { IoIosTennisball } from "react-icons/io";
import { IoTennisballOutline } from "react-icons/io5";
import { RiLoginCircleFill } from "react-icons/ri";
import { FiUser } from "react-icons/fi";
import { Link } from '@/i18n/routing';
import { useSession } from "next-auth/react";
import { VscAccount } from "react-icons/vsc";
import { MdAccountCircle } from "react-icons/md";
import AuthPopup from '../login-order/loginOrdinaryPopup';
import { useState } from 'react';
import MobileMenu from "./MobileMenu";
import { useTranslations } from 'next-intl';
const LanguageSelect: React.FC = () => {
  const pathname = usePathname();
  const router = useRouter();
const { data: session, status } = useSession();
  const scrollToSection = (id: string) => {
    if (pathname === '/') {
      // Already on home page, just scroll
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // Navigate to home with hash — browser will jump to section
      router.push(`/#${id}`);
    }
  };

  const [isAuthOpen, setIsAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState<"login" | "signup">("login");
  const th = useTranslations('Padel-Master-The-Game-Home-header');
  const openLogin = () => {
    setAuthMode("login");
    setIsAuthOpen(true);
  };

  const openCrypto = () => {
    setAuthMode("login");
    setIsAuthOpen(true);
  };


  return (
    <>

   <MobileMenu/>

      <div className="hidden xl:flex gap-3 uppercase select-none tracking-wide font-semibold items-end  text-white">
        <button
         onClick={() => scrollToSection('content')}
          className="flex gap-1 items-center uppercase hover:underline hover:text-b"
        >
          <IoTennisballOutline className='text-b' size={12}/>
         {th("Summary")} 
        </button>

        <button
         onClick={() => scrollToSection('pack')}
          className="flex gap-1 items-center uppercase hover:underline hover:text-b"
        >
          <IoTennisballOutline className='text-b' size={12}/>
          {th("eBook-Pack")} 
        </button>
<Link href="/contact-us">
        <button
          className="flex gap-1 items-center uppercase hover:underline hover:text-b"
        >
          <IoTennisballOutline className='text-b' size={12}/>
       {th("Contact-Us")}    
        </button></Link>
{status === "authenticated" ? (
            <Link href="/account" rel="preload"  className="flex gap-1 items-center uppercase text-b hover:text-white hover:underline">
         {th("Account")}      
              <VscAccount  size={18}  />
            </Link>
          ) : (
             <button
         onClick={openLogin}
          className="flex gap-1 items-center  uppercase text-b hover:text-white hover:underline"
        >
        
         {th("Login-Sign")}
            <RiLoginCircleFill size={18}/>
        </button>
          )}
          
      </div>
       <AuthPopup
              isOpen={isAuthOpen}
              onClose={() => setIsAuthOpen(false)}
              initialMode={authMode}
            />
    </>
  );
};

export default LanguageSelect;